import { eventGroupsAdapterSelectors } from '../redux/slices/eventGroups';
import { eventsAdapterSelectors } from '../redux/slices/events';
import { createSelector } from 'reselect';
import {
  currentWorkspaceResourceById,
  defaultResourceSelector,
} from './defaultSelectorUtils';

const getCurrentWorkspaceEventsFromStore = (state) =>
  state.currentWorkspace.events;

export const currentWorkspaceEvents = createSelector(
  getCurrentWorkspaceEventsFromStore,
  (state) => (id) => eventsAdapterSelectors.selectById(state, id),
  (id) => currentWorkspaceResourceById(id, eventGroupsAdapterSelectors),
  (eventIds, getEventsById, getEventGroupById) =>
    eventIds.map((eventId) =>
      defaultResourceSelector({
        main: {
          resourceId: eventId,
          getResourceById: getEventsById,
        },
        relations: [
          {
            key: 'eventGroup',
            getResourceById: getEventGroupById,
          },
        ],
      })
    )
);

// Selector factory that returns a memoized selector for a specific event ID
export const makeSelectEventById = () => {
  // This function is called once to create the selector instance.
  // The returned selector will be called with (state, eventId)
  return createSelector(
    [
      (state) => state, // Input selector: gets the global state
      (_, eventId) => eventId, // Input selector: gets eventId passed as the second arg to the selector instance
    ],
    (globalState, eventId) => {
      // Result function
      // eventsAdapterSelectors.selectById expects the global state
      const event = eventsAdapterSelectors.selectById(globalState, eventId);
      return {
        event: event || null,
        shouldFetch: !event, // True if event is not found, indicating a potential fetch is needed
      };
    }
  );
};
// Selector factory that returns a memoized selector for a specific event's color
export const makeSelectEventColorById = () => {
  return createSelector(
    [
      (state) => state, // Input selector: gets the global state
      (_, eventId) => eventId,
    ],
    (globalState, eventId) =>
      // eventsAdapterSelectors.selectById expects the global state
      eventsAdapterSelectors.selectById(globalState, eventId)?.color || null
  );
};
